/**
 * Canonical platform roles: director | instructor | alumno (only values stored in user.rol).
 */

export const PLATFORM_DIRECTOR_ROLES = ["director"];

export const COURSE_ADMIN_ASSIGN_ROLES = ["director"];

export const INSTRUCTOR_ROLES = ["instructor"];

export const ALUMNO_ROLES = ["alumno"];

export const STAFF_ROLES = [...PLATFORM_DIRECTOR_ROLES, ...INSTRUCTOR_ROLES];

export const ROLES_CURSO_EDICION = ["director", "instructor"];

export const ROLES_CREAR_CURSO = ["director", "instructor"];

export const ROLES_REGISTRO_ALUMNOS = [...PLATFORM_DIRECTOR_ROLES, ...INSTRUCTOR_ROLES];

export const ROLES_GESTION_ANUNCIOS = [...PLATFORM_DIRECTOR_ROLES, ...INSTRUCTOR_ROLES];

export const ROLES_PROGRESO_ALUMNOS = ["instructor", "director"];

export function isPlatformDirector(rol) {
  return !!rol && PLATFORM_DIRECTOR_ROLES.includes(rol);
}

export function isInstructor(rol) {
  return rol === "instructor";
}

export function isAlumno(rol) {
  if (rol == null) return false;
  if (typeof rol !== "string") return false;
  const normalized = rol.trim();
  if (normalized === "") return false;
  return ALUMNO_ROLES.includes(normalized);
}

/**
 * Home after login: alumno → campus; instructor → instructor area; director → director area.
 */
export function getHomeRouteByRole(rol) {
  if (!rol || ALUMNO_ROLES.includes(rol)) return "/usuario/campus";
  if (isInstructor(rol)) return "/gestion-instructor";
  if (isPlatformDirector(rol)) return "/gestion-director";
  return "/usuario/campus";
}

export const ROLES_ALTA_USUARIO = [
  { value: "director", label: "Director (plataforma)" },
  { value: "instructor", label: "Instructor" },
  { value: "alumno", label: "Alumno" },
];

export const ROLES_ALTA_USUARIO_INSTRUCTOR = [{ value: "alumno", label: "Alumno" }];

/**
 * Directors always assign director/instructor/alumno. `puedeCrearUsuarios` is also
 * true for directors, so that flag alone must not lock the form to alumno.
 * @param {string | null | undefined} rol
 * @param {boolean} puedeCrearUsuarios
 * @returns {boolean}
 */
export function isAlumnoOnlyUserCreator(rol, puedeCrearUsuarios) {
  if (rol === "director") {
    return false;
  }
  if (rol === "instructor") {
    return true;
  }
  return puedeCrearUsuarios === true;
}

/**
 * @param {string | null | undefined} rol
 * @param {boolean} puedeCrearUsuarios
 * @returns {boolean}
 */
export function canAccessStaffUserRegistration(rol, puedeCrearUsuarios) {
  if (typeof rol === "string" && ROLES_REGISTRO_ALUMNOS.includes(rol)) {
    return true;
  }
  return puedeCrearUsuarios === true;
}

export function isCanonicalUserRole(rol) {
  return rol === "director" || rol === "instructor" || rol === "alumno";
}

export function getUserRoleLabel(rol) {
  if (!rol) return "";
  const row = ROLES_ALTA_USUARIO.find((r) => r.value === rol);
  if (row) return row.label;
  return rol;
}

export const MESSAGING_ROLE_LABELS = {
  director: "Director",
  instructor: "Instructor",
  alumno: "Alumno",
};

export function getMessagingRoleLabel(key) {
  return MESSAGING_ROLE_LABELS[key] || key;
}
